<template>
  <!-- Subscription bar hidden by default in Skywalker design -->
  <div v-if="false" class="viq-sub-bar">
    <span class="viq-sub-bar__label">{{ verticalLabel }}</span>
    <span v-if="tierLabel" class="viq-sub-bar__tier">{{ tierLabel }}</span>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "ViqSubscriptionBar",
  computed: {
    ...mapState("Auth", ["subscriptions"]),
    showBar() {
      return !!this.subscriptions;
    },
    verticalLabel() {
      const vertical = process.env.PRODUCT_VERTICAL || "payments_compliance";
      return vertical === "financial_services"
        ? "Financial Services"
        : "Payments Compliance";
    },
    tierLabel() {
      if (!this.subscriptions || !this.subscriptions.permissions) return "";
      const perms = this.subscriptions.permissions;
      if (perms.includes("premium") || perms.includes("enterprise")) return "Premium";
      if (perms.includes("professional")) return "Professional";
      if (perms.includes("essentials")) return "Essentials";
      return "";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/viq.scss";

.viq-sub-bar {
  display: flex;
  align-items: center;
  gap: $viq-space-sm;
  padding: $viq-space-sm $viq-space-md;
  background: $viq-bg-primary;
  border: 1px solid $viq-border;
  border-radius: $viq-radius-md;
  margin-bottom: $viq-space-md;
  font-size: $viq-font-sm;
  width: fit-content;

  &__label {
    color: $viq-text-primary;
    font-weight: 600;
  }

  &__tier {
    padding: 2px 8px;
    background: $viq-accent-light;
    color: $viq-accent;
    border-radius: $viq-radius-full;
    font-size: $viq-font-xs;
    font-weight: 600;
  }
}
</style>
